import { Outlet } from 'react-router-dom'
import TourLauncher from '~/helpers/tour/TourLauncher'
import ConsentDialogs from '~/pages/components/ConsentDialogs'
import ImpersonationBanner from '~/pages/components/ImpersonationBanner'
import ContactPanel from '~/pages/help/components/ContactPanel'
import RouteAnnouncer from '~/pages/layouts/RouteAnnouncer'

function Root() {
  return (
    <>
      <RouteAnnouncer />
      <ImpersonationBanner />
      <Outlet />
      <ConsentDialogs />
      <ContactPanel />
      <TourLauncher />
    </>
  )
}

export default Root
